module.exports = "/_next/static/images/bni-6929f7d6c06302a2c34c1e3bec293598.svg";